
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

import IsknDataComboBox from '../IsknDataComboBox';

import SelectOpsubComboBox from './SelectOpsubComboBox';

const classNames = mergeStyleSets({
    SelectOpsubWithIsknDate: {
        paddingTop: 16
    }
});

const SelectOpsubWithIsknDate = ({
    getOpsub,
    isknDate,
    opsubItem,
    opsubItems,
    projectId,
    projectKatuzeKod,
    token,
    onChange
}) => {

    React.useEffect(() => {
        if (isknDate && (opsubItems.length === 0)) {
            getOpsub(
                token, projectId, projectKatuzeKod, isknDate
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isknDate]);

    const handleChangeIsknDate = (isknDate_) => {
        onChange(isknDate_, opsubItem);
    }

    const handleChangeOpsub = (opsubItem_) => {
        onChange(isknDate, opsubItem_);
    }

    return (
        <Stack className={classNames.SelectOpsubWithIsknDate} tokens={{childrenGap: 16}}>
            <IsknDataComboBox
                isknDate={isknDate}
                onChange={handleChangeIsknDate}
            />
            {(isknDate && (opsubItems.length === 0))
                ? <div>Načítám seznam vlastníků...</div>
                : null
            }
            {(isknDate && (opsubItems.length > 0))
                ? <>
                    <Stack horizontal>
                        <Stack.Item grow>Počet načtených vlastníků: {opsubItems.length}</Stack.Item>
                    </Stack>
                    <SelectOpsubComboBox
                        opsubItems={opsubItems}
                        onChange={handleChangeOpsub}
                    />
                </>
                : null
            }
            {(isknDate && opsubItem)
                ? <Stack>
                    <Text bold>Vybraný vlastník</Text>
                    <Stack horizontal wrap tokens={{childrenGap: 4}}>
                        <Text>{opsubItem._name}, </Text>
                        <Text>{opsubItem._rcico}, </Text>
                        <Text>{opsubItem._address}</Text>
                    </Stack>
                </Stack>
                : null
            }
        </Stack>
    );
}

export default SelectOpsubWithIsknDate;
